module.exports = __webpack_public_path__ + "img/PG2-2-258x195.a2b807e6.png";